<template>
  <collection
    name="strip"
    :loading="loading"
    :options="options"
    :data="strips"
    v-model="collection"
  >
    <template v-slot:item="slotProps">
      <strip-preview v-bind="slotProps.record" route-name="Comic" />
    </template>
  </collection>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import searchConfig from '@/utilities/searchConfig';
import Collection from '@/components/Collection.vue';
import StripPreview from '@/views/comic/StripPreview.vue';

export default {
  name: 'Archive',
  components: {
    Collection,
    StripPreview,
  },
  data() {
    return {
      loading: null,
      collection: null,
      options: {
        sort: true,
        search: {
          ...searchConfig,
          keys: ['name', 'number'],
        },
      },
    };
  },
  computed: {
    ...mapGetters(['getAllStrips']),
    strips() {
      return this.getAllStrips({
        sort: this.sort,
        isPublished: true,
      });
    },
    sort() {
      return this.collection && this.collection.sortValue;
    },
  },
  methods: {
    ...mapActions(['fetch', 'fetchAllStrips']),
    load() {
      this.loading = true;
      this.fetchAllStrips({
        published: true,
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  mounted() {
    this.load();
  },
  watch: {
    sort() {
      this.load();
    },
  },
};
</script>
